import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import img from "../../assets/images/background/13a.jpg";
import ProjectsImg1 from "../../assets/images/projects/3.jpg";
import ProjectsImg2 from "../../assets/images/projects/4.jpg";
import ProjectsImg3 from "../../assets/images/projects/5.jpg";
import ProjectsImg4 from "../../assets/images/projects/6.jpg";
import ProjectsImg5 from "../../assets/images/projects/7.jpg";
import ProjectsImg6 from "../../assets/images/projects/8.jpg";
import ProjectsImg7 from "../../assets/images/projects/9.jpg";
import { useTranslation } from "react-i18next";

const projects = [
  { img: ProjectsImg1, name: "New Capital" },
  { img: ProjectsImg2, name: "Badr City" },
  { img: ProjectsImg3, name: "Oubour City" },
  { img: ProjectsImg4, name: "6th of October City" },
  { img: ProjectsImg5, name: "Ain Sokhna" },
  { img: ProjectsImg6, name: "El Sadat City" },
  { img: ProjectsImg7, name: "Down Town Delta" },
  { img: ProjectsImg1, name: "15 May City" },
];

function MegaProjects() {
  const { t } = useTranslation();

  return (
    <>
      <MainHeader />
      <PageHeader image={img} title={t("Mega Projects")} />

      <section className="mega-projects-section">
        <div className="container">
          <span className="page-section-label">{t("Projects")}</span>
          <h2 className="inner-page-heading">{t("Mega Projects")}</h2>
          <p className="mega-projects-intro">
            {t("Our Steel Rebar approved and supplied in Iconic Construction sites in Egypt :")}
          </p>
          <p className="mega-projects-intro" style={{ marginTop: "-20px" }}>
            {t("New Capital- Badr City- Oubour City- 6th of October City- Ain Sokhna- 15 May City - El Sadat City- Down Town Delta.")}
          </p>

          <div className="row g-4 mt-2">
            {projects.map((p, i) => (
              <div key={i} className="col-lg-4 col-sm-6">
                <div className="project-card">
                  <img src={p.img} alt={p.name} />
                  <div className="project-card-overlay">
                    <p className="project-card-name">{p.name}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default MegaProjects;
